import {useIamService} from '../../controllers/DashboardServiceController'
import styles from './Home.module.css'

export function Home() {
    const iam = useIamService()
    const userGroups = iam.userGroups
    return <h3>Hi! you are a member of <span class={styles.userGroup}>{userGroups()}</span></h3>
}
